export default "__VITE_ASSET__CNQ8t0Ll__"